import { NextImageSrc } from '@vertex-protocol/web-common';
import aaveIcon from './tokenIcons/aave.svg';
import adaIcon from './tokenIcons/ada.svg';
import apeIcon from './tokenIcons/ape.svg';
import aptIcon from './tokenIcons/apt.svg';
import arbIcon from './tokenIcons/arb.svg';
import atomIcon from './tokenIcons/atom.svg';
import avaxIcon from './tokenIcons/avax.svg';
import bchIcon from './tokenIcons/bch.svg';
import benjiIcon from './tokenIcons/benji.svg';
import beraIcon from './tokenIcons/bera.svg';
import blastIcon from './tokenIcons/blast.svg';
import blurIcon from './tokenIcons/blur.svg';
import bnbIcon from './tokenIcons/bnb.svg';
import brettIcon from './tokenIcons/brett.svg';
import btcIcon from './tokenIcons/btc.svg';
import compIcon from './tokenIcons/comp.svg';
import crvIcon from './tokenIcons/crv.svg';
import degenIcon from './tokenIcons/degen.svg';
import dogeIcon from './tokenIcons/doge.svg';
import dotIcon from './tokenIcons/dot.svg';
import dydxIcon from './tokenIcons/dydx.svg';
import eigenIcon from './tokenIcons/eigen.svg';
import enaIcon from './tokenIcons/ena.svg';
import ethIcon from './tokenIcons/eth.svg';
import filIcon from './tokenIcons/fil.svg';
import galaIcon from './tokenIcons/gala.svg';
import gmci30Icon from './tokenIcons/gmci30.svg';
import gmMemeIcon from './tokenIcons/gmmeme.svg';
import goatIcon from './tokenIcons/goat.svg';
import honey from './tokenIcons/honey.svg';
import icpIcon from './tokenIcons/icp.svg';
import imxIcon from './tokenIcons/imx.svg';
import injIcon from './tokenIcons/inj.svg';
import jtoIcon from './tokenIcons/jto.png';
import jupIcon from './tokenIcons/jup.svg';
import ldoIcon from './tokenIcons/ldo.svg';
import linkIcon from './tokenIcons/link.svg';
import ltcIcon from './tokenIcons/ltc.svg';
import memeIcon from './tokenIcons/meme.svg';
import methIcon from './tokenIcons/meth.svg';
import mkrIcon from './tokenIcons/mkr.svg';
import mntIcon from './tokenIcons/mnt.svg';
import nearIcon from './tokenIcons/near.svg';
import ondoIcon from './tokenIcons/ondo.svg';
import opIcon from './tokenIcons/op.svg';
import pepeIcon from './tokenIcons/pepe.svg';
import polIcon from './tokenIcons/pol.svg';
import pythIcon from './tokenIcons/pyth.svg';
import sIcon from './tokenIcons/s.svg';
import scrIcon from './tokenIcons/scr.svg';
import seiIcon from './tokenIcons/sei.svg';
import snxIcon from './tokenIcons/snx.svg';
import solIcon from './tokenIcons/sol.svg';
import stxIcon from './tokenIcons/stx.svg';
import suiIcon from './tokenIcons/sui.svg';
import tiaIcon from './tokenIcons/tia.svg';
import tonIcon from './tokenIcons/ton.svg';
import trumpIcon from './tokenIcons/trump.webp';
import trxIcon from './tokenIcons/trx.svg';
import uniIcon from './tokenIcons/uni.svg';
import usdbIcon from './tokenIcons/usdb.svg';
import usdcIcon from './tokenIcons/usdc.svg';
import usdtIcon from './tokenIcons/usdt.svg';
import vlpIcon from './tokenIcons/vlp.svg';
import vovrtxIcon from './tokenIcons/vovrtx.svg';
import vrtxIcon from './tokenIcons/vrtx.svg';
import wbtcIcon from './tokenIcons/wbtc.svg';
import wethIcon from './tokenIcons/weth.svg';
import wifIcon from './tokenIcons/wif.svg';
import wldIcon from './tokenIcons/wld.svg';
import wstEthIcon from './tokenIcons/wsteth.svg';
import xautIcon from './tokenIcons/xaut.svg';
import xrpIcon from './tokenIcons/xrp.svg';
import zroIcon from './tokenIcons/zro.svg';
import hypeIcon from './tokenIcons/hype.svg';
import zecIcon from './tokenIcons/zec.svg';
import monIcon from './tokenIcons/mon.svg';
import fartcoinIcon from './tokenIcons/fartcoin.svg';
import pumpIcon from './tokenIcons/pump.svg';
import taoIcon from './tokenIcons/tao.svg';
import xmrIcon from './tokenIcons/xmr.svg';
import litIcon from './tokenIcons/lit.svg';
import penguIcon from './tokenIcons/pengu.svg';
import uselessIcon from './tokenIcons/useless.svg';
import asterIcon from './tokenIcons/aster.svg';
import xplIcon from './tokenIcons/xpl.svg';
import wlfiIcon from './tokenIcons/wlfi.svg';
import axsIcon from './tokenIcons/axs.svg';
import skyIcon from './tokenIcons/sky.svg';
import virtualIcon from './tokenIcons/virtual.svg';
import skrIcon from './tokenIcons/skr.svg';

export interface TokenIconMetadata {
  asset: NextImageSrc;
}

export const TOKEN_ICONS = {
  aave: {
    asset: aaveIcon,
  },
  ada: {
    asset: adaIcon,
  },
  ape: {
    asset: apeIcon,
  },
  apt: {
    asset: aptIcon,
  },
  arb: {
    asset: arbIcon,
  },
  atom: {
    asset: atomIcon,
  },
  avax: {
    asset: avaxIcon,
  },
  bch: {
    asset: bchIcon,
  },
  benji: {
    asset: benjiIcon,
  },
  bera: {
    asset: beraIcon,
  },
  blast: {
    asset: blastIcon,
  },
  blur: {
    asset: blurIcon,
  },
  bnb: {
    asset: bnbIcon,
  },
  brett: {
    asset: brettIcon,
  },
  btc: {
    asset: btcIcon,
  },
  comp: {
    asset: compIcon,
  },
  crv: {
    asset: crvIcon,
  },
  degen: {
    asset: degenIcon,
  },
  doge: {
    asset: dogeIcon,
  },
  dot: {
    asset: dotIcon,
  },
  dydx: {
    asset: dydxIcon,
  },
  eigen: {
    asset: eigenIcon,
  },
  ena: {
    asset: enaIcon,
  },
  eth: {
    asset: ethIcon,
  },
  fil: {
    asset: filIcon,
  },
  gala: {
    asset: galaIcon,
  },
  gmMeme: {
    asset: gmMemeIcon,
  },
  gmci30: {
    asset: gmci30Icon,
  },
  goat: {
    asset: goatIcon,
  },
  honey: {
    asset: honey,
  },
  icp: {
    asset: icpIcon,
  },
  imx: {
    asset: imxIcon,
  },
  inj: {
    asset: injIcon,
  },
  jto: {
    asset: jtoIcon,
  },
  jup: {
    asset: jupIcon,
  },
  ldo: {
    asset: ldoIcon,
  },
  link: {
    asset: linkIcon,
  },
  ltc: {
    asset: ltcIcon,
  },
  meme: {
    asset: memeIcon,
  },
  meth: {
    asset: methIcon,
  },
  mkr: {
    asset: mkrIcon,
  },
  mnt: {
    asset: mntIcon,
  },
  near: {
    asset: nearIcon,
  },
  ondo: {
    asset: ondoIcon,
  },
  op: {
    asset: opIcon,
  },
  pepe: {
    asset: pepeIcon,
  },
  pol: {
    asset: polIcon,
  },
  pyth: {
    asset: pythIcon,
  },
  s: {
    asset: sIcon,
  },
  scr: {
    asset: scrIcon,
  },
  sei: {
    asset: seiIcon,
  },
  snx: {
    asset: snxIcon,
  },
  sol: {
    asset: solIcon,
  },
  stx: {
    asset: stxIcon,
  },
  sui: {
    asset: suiIcon,
  },
  tia: {
    asset: tiaIcon,
  },
  ton: {
    asset: tonIcon,
  },
  trump: {
    asset: trumpIcon,
  },
  trx: {
    asset: trxIcon,
  },
  uni: {
    asset: uniIcon,
  },
  usdb: {
    asset: usdbIcon,
  },
  usdc: {
    asset: usdcIcon,
  },
  usdt: {
    asset: usdtIcon,
  },
  vlp: {
    asset: vlpIcon,
  },
  vovrtx: {
    asset: vovrtxIcon,
  },
  vrtx: {
    asset: vrtxIcon,
  },
  wbtc: {
    asset: wbtcIcon,
  },
  weth: {
    asset: wethIcon,
  },
  wif: {
    asset: wifIcon,
  },
  wld: {
    asset: wldIcon,
  },
  wstEth: {
    asset: wstEthIcon,
  },
  xaut: {
    asset: xautIcon,
  },
  xrp: {
    asset: xrpIcon,
  },
  zro: {
    asset: zroIcon,
  },
  hype: {
    asset: hypeIcon,
  },
  zec: {
    asset: zecIcon,
  },
  mon: {
    asset: monIcon,
  },
  fartcoin: {
    asset: fartcoinIcon,
  },
  pump: {
    asset: pumpIcon,
  },
  tao: {
    asset: taoIcon,
  },
  xmr: {
    asset: xmrIcon,
  },
  lit: {
    asset: litIcon,
  },
  pengu: {
    asset: penguIcon,
  },
  useless: {
    asset: uselessIcon,
  },
  aster: {
    asset: asterIcon,
  },
  xpl: {
    asset: xplIcon,
  },
  wlfi: {
    asset: wlfiIcon,
  },
  axs: {
    asset: axsIcon,
  },
  sky: {
    asset: skyIcon,
  },
  virtual: {
    asset: virtualIcon,
  },
  skr: {
    asset: skrIcon,
  },
} satisfies Record<string, TokenIconMetadata>;
